import React from "react";
import { useNavigate } from "react-router-dom";
import PContent from "../../../../../atoms/text/PContent";
import type { SubmenuItem } from "../types/navigation";

interface SubmenuProps {
  items: SubmenuItem[];
}

const Submenu: React.FC<SubmenuProps> = ({ items }) => {
  const navigate = useNavigate();

  const handleItemClick = (item: SubmenuItem, event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (item.onClick) {
      item.onClick();
    } else if (item.href) {
      navigate(item.href);
    }
  };

  return (
    <div className="flex flex-col space-y-5 py-2 pl-4">
      {items.map((item, index) => (
        <a
          key={index}
          href={item.href || "#"}
          onClick={(e) => handleItemClick(item, e)}
          className="flex items-center space-x-2 text-sm text-gray-600 transition-colors hover:text-primary"
        >
          <PContent>{item.icon}</PContent>
          <PContent className="font-semibold hover:font-bold">{item.label}</PContent>
        </a>
      ))}
    </div>
  );
};

export default Submenu;
